import React from 'react';
import { Link } from 'react-router-dom';

const CreateAction = () => {
  return (
    <div className='container mt-4' data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center'>
        <h1>Action Creation</h1>
      </div>
      <div className='row d-flex justify-content-center border-bottom'>
        <h4>Choose an Action Type</h4>
      </div>

      <div className='row d-flex justify-content-center mt-4'>
        <Link to='/CreateChangeDailyBudget' className='btn btn-outline-primary'>
          Change Daily Budget
        </Link>
      </div>
      <div className='row d-flex justify-content-center mt-4'>
        <Link to='/CreateChangeBidAmount' className='btn btn-outline-primary'>
          Change Bid Amount
        </Link>
      </div>
      <div className='row d-flex justify-content-center mt-4'>
        <Link to='/CreateChangeRoasBidConstraints' className='btn btn-outline-primary'>
          Change ROAS Bid Constraints
        </Link>
      </div>
      <div className='row d-flex justify-content-center mt-4'>
        <Link to='/CreateChangeStatus' className='btn btn-outline-primary'>
          Change Status
        </Link>
      </div>
      <div className='row d-flex justify-content-center mt-4'>
        <Link to='/CreateDuplicateCampaign' className='btn btn-outline-primary'>
          Duplicate Campaign
        </Link>
      </div>
      <div className='row d-flex justify-content-center mt-4'>
        <Link to='/CreateDuplicateDiffAccount' className='btn btn-outline-primary'>
          Duplicate Different Account
        </Link>
      </div>
    </div>
  );
};

export default CreateAction;
